export default __webpack_public_path__ + "static/media/who-we-are-Header-Mobile.632e1353.jpg";